import ConsoleApi from "@/consoleapi/consoleApi";
import {AxiosResponse} from "axios";


export default class Number extends ConsoleApi{

    protected baseResource = '/numbers';

    /**
     * @param accountId
     * @param providerId
     */
    public get(accountId: string, providerId: string): Promise<AxiosResponse>{
        this.resource = '/providers/' + providerId + this.baseResource;
        //console.log(this.requestUri + this.getAccountResource(accountId));
        return this.axios.get(this.requestUri + this.getAccountResource(accountId), {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }

    /**
     * @param accountId
     * @param providerId
     */
    public purchase(accountId: string, providerId: string): Promise<AxiosResponse>{
        this.resource = '/providers/' + providerId + this.baseResource;
        //console.log(this.requestUri + this.getAccountResource(accountId));
        //console.log(this.bearerToken);
        return this.axios.post(this.requestUri + this.getAccountResource(accountId) + '/purchase', {},{
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }
}